import Renderer from "../Renderer";
import Utils from "../utils/Utils";

/**
 *
 *
 * @author Stefano
 * @date 17-12-2019
 */
export default class SitemapPanel {
    constructor(panelElement) {
        this.sitemapPanel = panelElement;
    }

    renderSitemap(data) {
        Renderer.registerPartial("sitemap_repeat", document.getElementById("HB-sidemenu-sitemap-repeat").innerHTML);
        const template = document.getElementById("HB-sidemenu-sitemap").innerHTML,
            { spreads, depth } = this.addSpreadDataToStructure(data),
            renderData = {
                left: spreads[0],
                right: depth ? spreads : spreads[0].children, // dirty fix remove top lvl is we only have 1 lvl
                data_url: window.data_domain,
                backToOverviewText: window.interface_settings?.settings?.text?.sidemenu.sitemap.overview,
                overviewEnabled: window.interface_settings?.settings?.overview_enabled,
                meta: {
                    meta_title: this.getTitle(),
                    meta_description: this.getDescription(),
                },
            },
            html = Renderer.renderSource(template, renderData);
        Renderer.nativeInject(this.sitemapPanel, html);

        document.querySelectorAll(".sitemap-spread-title").forEach((entry) => {
            entry.addEventListener("click", (e) => e.currentTarget.classList.toggle("show"));
        });

        this.sitemapPanel.addEventListener("click", (event) => this.sitemapClicked(event));
    }

    addSpreadDataToStructure(spreads) {
        let depth = false;
        spreads.forEach((entry, index) => {
            if (entry.spread_id) {
                entry.spread = window.frontend.dataHelper.getSpreadById(
                    window.frontend.getCurrentIssueId(),
                    entry.spread_id,
                );
            }
            if (entry.children) {
                this.addSpreadDataToStructure(entry.children);
            }
            if (index > 0 && entry.spread) {
                depth = true;
            }
        });
        return { spreads, depth };
    }

    sitemapClicked(event) {
        let target = event.target;
        if (target.dataset && target.dataset.navspread) {
            event.preventDefault();
            event.stopPropagation();
            window.dispatchEvent(
                Utils.createEvent("MaglrHistoryPush", {
                    detail: { issueId: target.dataset.navissue, spreadId: target.dataset.navspread },
                }),
            );
        }
    }

    getDescription() {
        let issue = window.frontend.dataHelper.getCurrentIssue();
        let description = "";
        if (issue?.js_key_value) {
            description = issue.js_key_value.filter((item) => {
                if (item.js_key_key_id === 25) {
                    return item;
                }
            });
        }
        return (
            description[0]?.value ||
            window.interface_settings?.settings?.text?.meta_description ||
            window.interface_settings?.settings?.text?.overview_description
        );
    }

    getTitle() {
        let issue = window.frontend.dataHelper.getCurrentIssue();
        let title = "";
        if (issue?.js_key_value) {
            title = issue.js_key_value.filter((item) => {
                if (item.js_key_key_id === 26) {
                    return item;
                }
            });
        }
        return title[0]?.value || issue?.issue_title;
    }
}
